import {
  type Resignation,
  type ResignationApi,
  ResignationStatus,
} from '@omnipresentgroup/types';

import { DEFAULT_EMPLOYMENT } from '../employments';
import { DEFAULT_EMPLOYEE_USER } from '../users';

export const DEFAULT_RESIGNATION: Resignation = {
  id: 'de5be54f-5102-45cf-be41-df7913175e19',
  // eslint-disable-next-line no-magic-numbers
  employeeId: DEFAULT_EMPLOYEE_USER.roles[0].id || '',
  // eslint-disable-next-line no-magic-numbers
  companyId: DEFAULT_EMPLOYEE_USER.roles[0].tenantId || '',
  employmentId: DEFAULT_EMPLOYMENT.id,
  status: ResignationStatus.REQUESTED,
  employeeLastWorkingDay: '2024-12-31',
  isManagerAware: true,
  employeeScheduledLeaves: ['daysOwed'],
  employeeNumberOfVacationsDays: 10,
  resignationReason: 'jobSatisfaction',
  createdBy: 'auth0|6348088d0913a31d51a3a763',
  createdAt: '2024-11-07T16:33:57.669Z',
};

export const generateResignations = (override: Partial<Resignation> = {}) => ({
  ...DEFAULT_RESIGNATION,
  ...override,
});

export const DEFAULT_RESIGNATIONS_RESPONSE: ResignationApi = [
  DEFAULT_RESIGNATION,
];
